import {CommonModule, NgIf} from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { EventsWebsocketService } from "../../services/entities/events-websocket.service";
import {
  selectCameraTarget,
  selectCameraZoomTarget,
} from "src/app/state/camera/camera.selector";
import { ImageProperties } from "src/app/state/entities/component-properties-dto/images.properties.dto";
import {
  reactionEmojis,
  ReactionProperties,
} from "src/app/state/entities/component-properties-dto/reactions.properties.dto";
import { entityActions } from "src/app/state/entities/entity.actions";
import {
  EntityType,
  Components,
  CollisionType,
} from "src/app/state/entities/entity.model";
import { FileUploadStatus } from "src/app/state/interface/dtos/file-upload-status.dto";
import { selectFileUploadStatuss } from "src/app/state/interface/interface.selector";
import { Vector3 } from "three";
import { generateUUID } from "three/src/math/MathUtils.js";
import {Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {interfaceActions} from "../../state/interface/interface.actions";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {User} from "../../auth/primitives/user";

@Component({
  selector: "binsta-new-image",
  standalone: true,
  imports: [
    Base64ImageComponent,
    FaIconComponent,
    FormsModule,
    NgIf
  ],
  templateUrl: "./new-image.component.html",
  styleUrl: "./new-image.component.scss",
})
export class NewImageComponent {
  cameraTarget: Vector3 = new Vector3();
  cameraZoom: number;
  user: User
  // @Output()
  // close = new EventEmitter();

  uploadStatuss: FileUploadStatus[] = [];
  uploadsCompleted: boolean[] = [];
  errorUploadsNotCompleted = false;

  allUploadsCompleted = true;

  textInput = "";

  constructor(
    private store: Store,
    private router: Router,
    private fileService: FilesService,
    private websocketService: EventsWebsocketService,
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.cameraTarget.copy(target);
    });
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      this.cameraZoom = target;
    });
    this.store
      .select(selectFileUploadStatuss)
      .subscribe((fileUploadStatuss) => {
        this.uploadStatuss = Object.values(fileUploadStatuss);
        this.uploadsCompleted = this.uploadStatuss.map((x) => x.completed);
        this.allUploadsCompleted = this.areAllUploadsCompleted();
      });
    this.store.select(AuthSelectors.selectUser)
        .subscribe(async (user) => {
          this.user = user
        })
  }

  async ngOnInit(): Promise<void> {}

  removeImage(id: string) {
    this.store.dispatch(interfaceActions.clearFileUpload({
      fileId: id
    }))
  }

  closeHolder() {
    this.store.dispatch(interfaceActions.clearFileUploads())
    this.textInput = "";
    this.router.navigate([{outlets: {'new-modal-pane': null}}])
  }

  async filesSelected(files) {
    this.allUploadsCompleted = false;
    const proms = [];
    for (let file of files.target.files) {
      proms.push(this.uploadFile(file));
    }
    await Promise.allSettled(proms);
  }

  async uploadFile(file) {
    const fileIdToUpload = await this.fileService.getServerFileIdForNewFile(file);
    this.fileId = fileIdToUpload;
    await this.fileService.uploadFile(fileIdToUpload, file);
  }

  fileId: string = "";

  async getFile() {
    const file = await this.fileService.getFile(this.fileId);
    await this.fileService.downloadFile(document, file.fileData, file.filename);
  }

  areAllUploadsCompleted() {
    return this.uploadStatuss.reduce((prev, curr) => {
      return prev && curr.completed;
    }, true);
  }

  post() {
    this.errorUploadsNotCompleted = false;
    if (!this.areAllUploadsCompleted()) {
      this.errorUploadsNotCompleted = true;
      return;
    }
    const imageProps: ImageProperties[] = this.uploadStatuss.map((upload) => {
      return {
        fileId: upload.id,
        description: `This is image: ${upload.id}`,
        userDefined: {
          tags: [],
          users: [],
        },
        inferred: {
          tags: [],
        },
      };
    });
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: generateUUID(),
          type: EntityType.Gallery,
          ownerId: this.user.id,
          components: [Components.text, Components.images],
          coord: new Vector3(
            this.cameraTarget.x,
            this.cameraTarget.y,
            // this.cameraZoom - 700,
            Math.random() * 50,
          ),
          componentProperties: {
            Text: this.textInput,
            Images: imageProps,
            Reactions:  {
              smallScaleReactions: [],
              commonReactionsCounters: {},
            },
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
    // this.close.emit(true);
    this.closeHolder()
  }

  generateRandomReactionCounters(
    emojis: string[],
    maxCount = 5000,
  ): {[reaction: string]: number}[] {
    return emojis.slice(0, 4).map((reaction) => ({
      [reaction]: Math.floor(Math.random() * maxCount), // 0..maxCount-1
    }));
  }

  buildReactions(count: number) {
    const reactionsList = reactionEmojis;
    let reactions: ReactionProperties = {
      smallScaleReactions: [],
      commonReactionsCounters: this.generateRandomReactionCounters(
        reactionsList,
        5000,
      ),
    };
    for (let x = 0; x < count; x++) {
      reactions.smallScaleReactions.push({
        userId: "123",
        reaction:
          reactionsList[Math.round(Math.random() * reactionsList.length - 1)],
      });
    }
    return reactions;
  }
}
